exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.admin_content[data-v-7ba5bd90] {\n  padding-left: 80px !important;\n}\n.overflow-x-hidden[data-v-7ba5bd90] {\n  overflow-x: hidden;\n}\n", ""]);

